module.exports = __webpack_public_path__ + "img/hips.bcb986bd.png";